export default class EventGameTiebreakerModel {
  public statTiebreakerEnabled: boolean;
  public statTotal: number;
}
